var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supplier_photos"},[_c('v-container',[_c('v-row',[_c('v-col',[_c('iframe',{staticStyle:{"border":"solid"},attrs:{"src":_vm.googleMapUrl,"width":"97%","height":"400px"}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }